import React from 'react'
import styled from 'styled-components/macro'

const H3 = styled.h3`
  color: darkgrey;
`

export default () => (
  <footer className="container py-5">
    <div className="row">
      <H3>© ELPA DIGITAL 2019</H3>
    </div>
  </footer>
)
